import { useIntl } from "react-intl";

import { SubmitButton } from "@/components/signup/site-activation/components/common/submit-button";

export const JiraPaidEditionsSubmitButtonNewUser = () => {
    const intl = useIntl();

    const submitMessage = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
        defaultMessage: "Go to Jira"
    });

    return <SubmitButton submitMessage={submitMessage} />;
};
